module.exports = __webpack_public_path__ + "static/img/UBIDOMO_slide-2-1500x630.778ecdcf.jpg";